import { Box } from "@mui/material";
import React from "react";
import AppRoutes from "./services/routes/routes";

const App: React.FC = () => {
  return <Box>
    <AppRoutes />
  </Box>;
};

export default App;
